module.exports = __webpack_public_path__ + "img/full-screen.83ff0ae2.svg";